import React, { useMemo } from "react";
import { Formik } from "formik";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import { useCartPriceUIContext } from "./CartPriceUIContext";
import { CartPriceTable } from "./cart-price-table/CartPriceTable";

export default function CartPriceCard() {
  
  const priceUIContext = useCartPriceUIContext();
  const priceUIProps = useMemo(() => {
    return {
      ids: priceUIContext.ids,
      queryParams: priceUIContext.queryParams,
      setQueryParams: priceUIContext.setQueryParams,
      newPriceButtonClick: priceUIContext.newPriceButtonClick,
    };
  }, [priceUIContext]);

  return (
    <Card>
      <CardHeader title='Cart Price'>
        <CardHeaderToolbar>
          <button
            type='button'
            className='btn btn-primary'
            onClick={priceUIProps.newPriceButtonClick}>
            <i className="fas fa-plus-circle"></i> Add New Cart Price
          </button>
        </CardHeaderToolbar>
      </CardHeader>{" "}  
      <CardBody>

        <CartPriceTable />
      </CardBody>
    </Card>
  );
}
